// Vendor
import { createAction, props } from '@ngrx/store';
export const setFundChartTitle = createAction('[Fund Chart] Set title', props());
